<template>
  <div class="text-container" :class="computedClass">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'TextContainer',
  props: {
    size: {
      type: String
    },
    alignCenter: {
      type: Boolean,
      default: false
    },
    justifyCenter: {
      type: Boolean,
      default: false
    },
    justifyEnd: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedClass () {
      return {
        'text-container-xs': this.size === 'xs',
        'text-container-sm': this.size === 'sm',
        'text-container-lg': this.size === 'lg',
        'text-container-xl': this.size === 'xl',
        'justify-items-center': this.alignCenter,
        'text-center': this.alignCenter,
        'justify-content-center': this.justifyCenter,
        'justify-content-end': this.justifyEnd
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.text-container
  display: grid
  grid-template-columns: minmax(0, 100%)
  &:not(.justify-content-center)
    justify-content: start
    +media-breakpoint-down(sm)
      justify-content: center!important
  &:not(.justify-items-center)
    justify-items: start
    text-align: left
    +media-breakpoint-down(sm)
      justify-items: center
      text-align: center
  +media-breakpoint-up(md)
    &-xs
      grid-template-columns: minmax(0, 400px)
    &-sm
      grid-template-columns: minmax(0, 500px)
    &-lg
      grid-template-columns: minmax(0, 750px)
    &-xl
      grid-template-columns: minmax(0, 900px)
</style>



// WEBPACK FOOTER //
// src/components/ui/TextContainer.vue